import { LinkButtonWrapperProps } from "../../../types";
import { secondaryOutlineClass, secondarySolidClass } from "./buttonStyles";
import { LinkButton } from "./LinkButton";

export const SecondaryLinkButton = ({
  children,
  href,
  cssClass,
  variant = "solid",
  testId,
  onClick,
}: LinkButtonWrapperProps) => {
  return (
    <LinkButton
      href={href}
      testId={testId}
      onClick={() => onClick && onClick()}
      cssClass={`${
        variant === "outline" ? secondaryOutlineClass : secondarySolidClass
      } ${cssClass ? cssClass : ""}`}
    >
      {children}
    </LinkButton>
  );
};
